import { render, staticRenderFns } from "./TabDetailSurvey.vue?vue&type=template&id=20972348&scoped=true"
import script from "./TabDetailSurvey.vue?vue&type=script&lang=js"
export * from "./TabDetailSurvey.vue?vue&type=script&lang=js"
import style0 from "./TabDetailSurvey.vue?vue&type=style&index=0&id=20972348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20972348",
  null
  
)

export default component.exports